"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var BrandEmailTemplateTplRawEditor_1 = require("./BrandEmailTemplateTplRawEditor");
var BrandEmailTemplateImagesList_1 = require("./BrandEmailTemplateImagesList");
var BrandEmailTemplateImageEditor_1 = require("./BrandEmailTemplateImageEditor");
var BrandEmailTemplateTestJSONEditor_1 = require("./BrandEmailTemplateTestJSONEditor");
var BrandEmailTemplateOperationEdit = /** @class */ (function (_super) {
    __extends(BrandEmailTemplateOperationEdit, _super);
    function BrandEmailTemplateOperationEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_template = "tab.template";
        _this.tab_images = "tab.images";
        _this.tab_test = "tab.test";
        return _this;
    }
    BrandEmailTemplateOperationEdit.prototype.componentWillMount = function () {
        this.setState({
            templateImageMode: "LIST",
            templateImageRecord: null
        });
        this.props.state.setExtBreadCrumbPath(["Управление шаблоном"]);
    };
    BrandEmailTemplateOperationEdit.prototype.backToRootClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BrandEmailTemplateOperationEdit.prototype.newTemplateImageClick = function () {
        this.setState({ templateImageMode: "NEW", templateImageRecord: null });
    };
    BrandEmailTemplateOperationEdit.prototype.editAppCurrencyClick = function (record) {
        this.setState({ templateImageMode: "EDIT", templateImageRecord: record });
    };
    BrandEmailTemplateOperationEdit.prototype.backToImagesListClick = function () {
        this.setState({ templateImageMode: "LIST", templateImageRecord: null });
    };
    BrandEmailTemplateOperationEdit.prototype.getTemplateImagesObject = function () {
        if (this.state.templateImageMode === "LIST") {
            return (React.createElement(BrandEmailTemplateImagesList_1.default, { state: this.props.state, data: this.props.dataImages, onNewClick: this.newTemplateImageClick.bind(this), onEditClick: this.editAppCurrencyClick.bind(this), onGoBack: this.backToRootClick.bind(this), record: this.props.record }));
        }
        if (this.state.templateImageMode === "NEW") {
            return (React.createElement(BrandEmailTemplateImageEditor_1.default, { data: this.props.dataImages, record: null, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToImagesListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.templateImageMode === "EDIT") {
            return (React.createElement(BrandEmailTemplateImageEditor_1.default, { data: this.props.dataImages, record: this.state.templateImageRecord, rootRecord: this.props.record, state: this.props.state, onGoBack: this.backToImagesListClick.bind(this), dialogSelectImage: this.props.dialogSelectImage }));
        }
        throw "No available render for active edit mode -> " + this.state.templateImageMode;
    };
    BrandEmailTemplateOperationEdit.prototype.getTPLRawEditorObject = function () {
        return (React.createElement(BrandEmailTemplateTplRawEditor_1.default, { data: this.props.dataTemplates, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), tplBase64: this.props.TPLBase64 }));
    };
    BrandEmailTemplateOperationEdit.prototype.getTestJSONEditorObject = function () {
        return (React.createElement(BrandEmailTemplateTestJSONEditor_1.default, { data: this.props.dataTemplates, record: this.props.record, state: this.props.state, onGoBack: this.backToRootClick.bind(this), testJSONBase64: this.props.JSONBase64 }));
    };
    BrandEmailTemplateOperationEdit.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_template },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "envelope" }),
                        "\u0428\u0430\u0431\u043B\u043E\u043D"), key: this.tab_template }, this.getTPLRawEditorObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "images" }),
                        "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"), key: this.tab_images }, this.getTemplateImagesObject()),
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "calendar-check" }),
                        "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430"), key: this.tab_test }, this.getTestJSONEditorObject()))));
    };
    return BrandEmailTemplateOperationEdit;
}(React.Component));
exports.default = BrandEmailTemplateOperationEdit;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/email/BrandEmailTemplateOperations.tsx
// module id = 1785
// module chunks = 0